import Download from "@/(front-desk)/(pages)/download/[category]/Download"

export const categoryList = {
    procedure: '作業辦法',
    handbook: '大會公告',
    winners: '得獎名單',
    medal: '得獎標章'
}
export async function generateStaticParams() {
    return Object.keys(categoryList).map((category) => ({
        category: category,
    }))
}
export default function download({ params }) {
    return (
        <Download category={params.category}/>
    )
}
